import ShippingProgress from './shippingProgress';
import packageStyles from './packageStatus.module.css';
import CollapsibleProductLineList from './collapsibleProductLineList';
import {useI18nContext} from '../../i18n/i18n-react';
import {
    Card,
    CardContent,
    CardHeader,
    Icon,
    IconSizes,
    Icons,
    InfoDialog,
    Link,
    Typography,
} from '@toppy-webshop/toppy-design-system';
import {Order} from '../../models/order';
import {useRef} from 'react';

const NoShipments = ({order}: {order: Order}) => {
    const {LL} = useI18nContext();
    const dialogRefs = useRef<HTMLDialogElement | null>(null);

    if (!order) {
        return <></>;
    }

    const {isCanceled, isRefunded, isPaid, isComplete} = order;

    let description = '';
    let title = '';

    if (isCanceled) {
        description = LL.order.state.canceled.description();
        title = LL.order.state.canceled.title();
    } else if (isRefunded) {
        description = LL.order.state.refunded.description();
        title = LL.order.state.refunded.title();
    } else if (!isPaid) {
        description = LL.order.state.pendingPayment.description();
        title = LL.order.state.pendingPayment.title();
    } else if (isComplete) {
        description = LL.shipment.state.delivered.title();
        title = LL.shipment.state.delivered.title();
    } else {
        description = LL.order.state.processing.description();
        title = LL.order.state.processing.title();
    }

    return (
        <Card>
            <CardHeader>
                <Typography
                    variant="h6"
                    component={'span'}
                    lineHeight={'tight'}
                    noMargin
                >
                    Bestelling #{order.orderNumber}
                </Typography>
            </CardHeader>
            <CardContent>
                <div className={packageStyles['info-wrapper']}>
                    <p className={packageStyles.description}>
                        <Typography size={'s'} weight={'bold'}>
                            {title}
                        </Typography>
                        <Link onClick={() => dialogRefs.current?.showModal()}>
                            <Icon
                                icon={Icons.INFO_BOX_FULL}
                                color="blue"
                                size={IconSizes.S}
                            />
                        </Link>
                    </p>

                    <InfoDialog
                        ref={el => {
                            dialogRefs.current = el;
                        }}
                        onClose={() => {
                            dialogRefs.current?.open &&
                                dialogRefs.current &&
                                dialogRefs.current?.close();
                        }}
                        title={'Wat dat betekend?'}
                        buttonText={LL.menu.close()}
                        buttonType={'outline'}
                        content={description}
                    />
                </div>
                {!isCanceled && !isRefunded && !isComplete && (
                    <ShippingProgress hasPackages={false} trackProgress={2} />
                )}
                {isComplete && (
                    <ShippingProgress
                        hasPackages={false}
                        isDelivered={true}
                        trackProgress={100}
                    />
                )}
            </CardContent>
            <CollapsibleProductLineList
                products={Object.values(order.items).map((item, index) => ({
                    key: index.toString(),
                    name: item.description,
                    qty: item.qty,
                }))}
            />
        </Card>
    );
};

export default NoShipments;
